export enum InternalIssueTypeEnum {
    MissingAol = 0,
    MissingPosition = 1,
    TimeInconsistency = 2,
    ReportFormatError = 3,
}
